export default "__VITE_ASSET__FQozPzKU__"